module.exports = __webpack_public_path__ + "static/media/punch1.d2bd4b80.mp3";